"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOW_DID_YOU_HEAR_ABOUT_US_MAX_LENGTH = exports.TIME_LOGGED_INC = void 0;
exports.TIME_LOGGED_INC = 5;
exports.HOW_DID_YOU_HEAR_ABOUT_US_MAX_LENGTH = 500;
//# sourceMappingURL=constants.js.map